import comp from "./CriteriaComment";
export default comp;
